import React from 'react';
import { Button, Form, Input, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { FORM_NOT_EMPTY_RULE } from '../../../../../utils';
import { PaddedButton } from '../styles';
import { ERROR_MESSAGES, LAYOUT_STYLES, TAIL_STYLES } from '../constants';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const RokuFastForm = ({ onSubmit, onBack }) => {
  return (
    <Form {...LAYOUT_STYLES} onFinish={onSubmit}>
      <Form.Item
        label="Device IFA"
        name="deviceIfa"
        rules={[
          { required: true, message: ERROR_MESSAGES.REQUIRED_DEVICE_IFA },
          {
            pattern: UUID_REGEX,
            message: ERROR_MESSAGES.INVALID_DEVICE_IFA,
          },
          FORM_NOT_EMPTY_RULE,
        ]}
        tooltip={{
          title: 'Roku Device Identifier for Advertising (UUID format)',
          icon: <InfoCircleOutlined />,
        }}
      >
        <Input placeholder="e.g., 9e149ead-cb89-518e-98a8-4a6156041010" />
      </Form.Item>
      <Form.Item
        label={
          <span>
            Nickname&nbsp;
            <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
              <InfoCircleOutlined />
            </Tooltip>
          </span>
        }
        name="nickname"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_NICKNAME }, FORM_NOT_EMPTY_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item {...TAIL_STYLES}>
        <Button onClick={onBack}>Back</Button>
        <PaddedButton type="primary" htmlType="submit">
          Submit
        </PaddedButton>
      </Form.Item>
    </Form>
  );
};

export default RokuFastForm;
